<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: keyof typeof variantMapping
  }>(),
  {
    variant: 'default'
  }
)

const variantMapping = {
  default: 'px-6 pb-6',
  mini: 'p-[30px]',
  coloredHeader: 'p-6'
}
</script>

<template>
  <div :class="variantMapping[variant]">
    <slot></slot>
  </div>
</template>
